<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <label for="">Nombre *</label>
                <input type="text" v-model="MaterialTrabajo.Nombre" placeholder="Nombre" class="form-control">
                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Nombre" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-lg-12">
                <label for="">Archivo</label>
                <div class="custom-file-input-image">
                    <input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
                    <input type="text" v-model="Archivo" class="form-control">
                    <button type="button" class=""><i class="fas fa-paperclip"></i></button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <label for="">Comentario</label>
                <textarea class="form-control" v-model="MaterialTrabajo.Comentario" cols="10" rows="10"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"MaterialTrabajo",
    props:["poBtnSave"],
    data() {
        return {
            Modal:true,
            FormName:'MaterialTrabajo',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            MaterialTrabajo:{
                IdMaterialTrabajo:0,
                IdTrabajador:0,
                Nombre:'',
                Comentario:'',
                Archivo:'',
            },
            Archivo:'Elegir Archivo (0.5MB)',
            errorvalidacion:[]
        }
    },
    methods: {
        Guardar(){
            let file = this.$refs.file.files[0];
            let formData=new FormData();
            formData.set('IdMaterialTrabajo',this.MaterialTrabajo.IdMaterialTrabajo);
            formData.set('IdTrabajador',this.MaterialTrabajo.IdTrabajador);
            formData.set('Nombre',this.MaterialTrabajo.Nombre);
            formData.set('Comentario',this.MaterialTrabajo.Comentario);
            formData.set('NombreArchivo',this.MaterialTrabajo.Archivo);
            formData.append('NombreArchivoFile',file);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('materialtrabajo/post',formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }
            }).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#MaterialTrabajo").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
        Limpiar(){
            const  input  = this.$refs.file;
            input .type = 'text'
            input .type = 'file';
            this.MaterialTrabajo={
                IdMaterialTrabajo:0,
                IdTrabajador:0,
                Nombre:'',
                Comentario:'',
                Archivo:'',
            }
            this.Archivo='Elegir Archivo (0.5MB)';
        },
        Recuperar(){
            this.$http.get('materialtrabajo/recovery',{
                params:{
                    IdMaterialTrabajo:this.MaterialTrabajo.IdMaterialTrabajo
                }
            }).then((res)=>{
                const objres=res.data.data.materialtrabajo;
                this.MaterialTrabajo.IdMaterialTrabajo=objres.IdMaterialTrabajo;
                this.MaterialTrabajo.IdTrabajador=objres.IdTrabajador;
                this.MaterialTrabajo.Nombre=objres.Nombre;
                this.MaterialTrabajo.Archivo=objres.Archivo;
                this.MaterialTrabajo.Comentario=objres.Comentario;
                this.Archivo=objres.Archivo;
            })
        },
        SubirArchivo(){
            const image = this.$refs.file.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extensiones permitidas .pdf');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.Archivo=image.name;
        }
    },
    created() {
        this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdTrabajador)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdTrabajador!==undefined) {
                this.MaterialTrabajo.IdTrabajador=IdTrabajador;
            }
            if (Id > 0) {
				this.MaterialTrabajo.IdMaterialTrabajo = Id;
				this.Recuperar();
			}
        });
    },
}
</script>

<style>

</style>
